import { FC } from 'react';
import { ColumnsType } from 'antd/lib/table';
import { ItemDetailsBox, ItemDetailsField, ItemDetailsFieldLabel } from './ItemDetails.styles';
import { H3 } from 'components/new-ui/base/typography/styles';

type Props = {
    itemNumber: number;
    record: any;
    columns: ColumnsType<any>;
    fixed: boolean;
};

const ItemDetails: FC<Props> = ({ itemNumber, record, columns, fixed }) => {
    return (
        <div>
            <H3 style={{ marginBottom: 4 }}>Item {itemNumber}</H3>
            <ItemDetailsBox $fixed={fixed}>
                {columns.map((column, index) => (
                    <ItemDetailsField key={(column.key as string) ?? index}>
                        <ItemDetailsFieldLabel>{column.title as React.ReactNode}</ItemDetailsFieldLabel>
                        <span>{(column as any).render?.(undefined, record, 0)}</span>
                    </ItemDetailsField>
                ))}
            </ItemDetailsBox>
        </div>
    );
};

export default ItemDetails;
